import React from 'react'

const HeaderButton = () => {

    return (
        <center>
            <div>
                <a href="#about"><button className="see">Checkout Portfolio<i className="fas fa-eye"></i></button></a>
            </div>
        </center>
    )
}

export default HeaderButton
